const yup = require("yup");

const addUserAnalyticSettings = yup.object().shape({
  settingName: yup.string().required("Name of Setting is required"),
});

export default addUserAnalyticSettings;
